import { render, staticRenderFns } from "./tradeTracker.vue?vue&type=template&id=815427f2&scoped=true"
import script from "./tradeTracker.vue?vue&type=script&lang=js"
export * from "./tradeTracker.vue?vue&type=script&lang=js"
import style0 from "./tradeTracker.vue?vue&type=style&index=0&id=815427f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815427f2",
  null
  
)

export default component.exports